var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "93px",
    viewBox: "0 0 84 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KeyFlag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KeyFlag",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14195153,17.6592044 C0.891594847,18.2657334 -0.0197034866,17.7931004 0,17.0616684 C0.180581861,7.69993791 21.9515992,-12.566325 41.719763,10.9584077 C66.324818,40.2276795 65.1030774,77.0281033 84,81.3057816 C68.7182279,84.7151342 66.3849036,80.9890276 60.0659009,77.6096518 C67.3162305,87.9266404 79.5837081,92.5880208 79.5837081,92.5880208 C81.3962905,93.7021556 36.5323725,95.0181338 32.8771649,60.6408284 C29.0917718,25.0904339 7.95165336,1.16401318 1.14195153,17.6592044",
    id: "Fill-311",
    fill: "#ED5353"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyFlag);
export default __webpack_public_path__ + "static/media/KeyFlag.cb445bddc8b64f7eb883d79da6348610.svg";
export { ForwardRef as ReactComponent };